import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

type GetOpenDockStopAppointmentFactoryDependencies = {
  repository: ShipmentRepository
}

type Params = {
  shipmentUUID: string
  stopIndex: number
  config: Partial<HttpClientConfig>
}

export function getOpenDockStopAppointmentFactory({
  repository,
}: GetOpenDockStopAppointmentFactoryDependencies) {
  return async function getOpenDockStopAppointment({ shipmentUUID, stopIndex, config }: Params) {
    try {
      return await repository.getOpenDockStopAppointment(shipmentUUID, stopIndex, config)
    } catch (error) {
      throw new Error('Could not get OpenDock stop appointment', { cause: error as Error })
    }
  }
}

export function getOpenDockStopAppointment({ shipmentUUID, stopIndex, config }: Params) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const fetch = getOpenDockStopAppointmentFactory({ repository })
  return fetch({ shipmentUUID, stopIndex, config })
}
